<template>
    <v-text-field
        v-bind='$attrs'
        :value='value'
        @input="v => $emit('input', v)"
    >
        <template #label>
            <slot name='label' />
        </template>
        <template #message>
            <slot name='message' />
        </template>

    </v-text-field>
</template>

<script>

    export default {
        name: 'BankCardNumberInput',
        inheritAttrs: false,
        props: ['value', 'agreement'],
        methods: {}
    };

</script>

<style scoped lang='scss'>
.v-input{
    :deep(input){
        word-spacing: 1rem;
        direction: ltr;
    }
}
</style>